<template>
  <el-col :span="24" align="middle" id="setup-password" v-loading="loading">
    <el-row type="flex" justify="start" align="middle" class="login-form-wrapper">
      <el-col :span="12" class="left-padded left-aligned-col">
        <el-row type="flex">
          <el-col :span="8"></el-col>
          <el-col :span="16">
            <el-row type="flex" justify="start" align="middle">
              <div class="grid-content login-row">
                <h3>Set Password</h3>
              </div>
            </el-row>
            <el-row type="flex" justify="start" align="middle" gutter="10" class="v-padded-s" v-if="instances && instances.length">
              <el-col :span="16" class="right-aligned-col">
                <el-select style="width: 100%;" v-model="instance" placeholder="Select an instance">
                  <el-option v-for="(v, i) in instances" :key="i" style="padding: 0;" :label="v.name" :value="v.url">
                    <el-row type="flex" align="middle" style="height: 36px; padding: 0 10px;">
                      <el-col style="height: 36px;" :span="21">
                        <div @click="handleInstanceSelect(v.url)" style="display: table; height: 36px; width: 100%;">
                          <span style="display: table-cell; vertical-align: middle; width: 100%;">
                            {{ v.name ? (v.name + ' ' + `(${formatInstanceURL(v.url)})`) : v.url }}
                          </span>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <el-row type="flex" align="middle" justify="end">
                          <el-button size="mini" icon="close" style="z-index: 1000;" @click="removeInstance(v.url)" />
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-option>
                  <el-option key="custom" label="Custom URL" style="padding: 0;" value="custom">
                    <el-row type="flex" align="middle" style="height: 36px;">
                      <div @click="addingCustomInstance = true" style="display: table; height: 36px; width: 100%; padding: 0 10px;">
                        <span style="display: table-cell; vertical-align: middle; width: 100%;">
                          Custom
                        </span>
                      </div>
                    </el-row>
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row
              v-if="!(instances && instances.length) || addingCustomInstance"
              type="flex"
              justify="start"
              align="middle"
              class="v-padded-s"
              style="padding: 10px 0;"
            >
              <el-col :span="24">
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <el-col :span="24" style="padding-bottom: 6px; font-size: 12px;">
                    Please enter an instance
                  </el-col>
                </el-row>
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <el-col :span="14">
                    <el-input v-model="instanceField" placeholder="Instance" />
                  </el-col>
                  <el-col :span="2">
                    <el-button
                      type="primary"
                      @click="addInstance"
                      icon="plus"
                      />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="Username" v-model="creds.username" :disabled="creds.username" ref="usernameField">
                    <template slot="prepend">Username</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s" v-show="hasToken()">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="********" type="password" v-model="creds.password" :disabled="!instance" ref="passwordField">
                    <template slot="prepend">New Password</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s" v-show="hasToken()">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="********" type="password" v-model="creds.password2" :disabled="!instance" ref="password2Field">
                    <template slot="prepend">Confirm Password</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s" v-show="hasToken()">
              <el-col :span="16" class="right-aligned-col">
                <template v-if="!loading">
                <el-button
                  type="primary"
                  size='small'
                  :disabled="addingCustomInstance"
                  @click="saveNewPassword"
                  icon="caret-right"
                  >     
                  Update
                </el-button>
              </template>
              <template v-else>
                <el-button
                  type="primary"
                  size='small'
                  icon="caret-right"
                  >        
                  Updating...
                 <i class="el-icon-loading loading-instances"></i>
                </el-button>
              </template>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" style="text-align: center;">
        <SplashText></SplashText>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
  import SplashText from '../../SplashText.vue'
  import { mapGetters } from 'vuex'
  import isUrl from 'is-url'
  import store from '@/store/store'

  export default {
    name: 'Setup New User',
    components: { SplashText },
    data () {
      return {
        instanceField: '',
        instance: '',
        creds: { username: '', password: '', password2: '', token: this.$route.query.token },
        addingCustomInstance: false,
        loading: false
      }
    },
    methods: {
      isUrl,
      /*
      * Adds an instance manually, sets it as active, and calls login()
      * @return void
      */
      async addInstance () {
        try {
          let field
          let exp = new RegExp(`^(https:\\/\\/)?([a-zA-Z0-9_-]+)(${this.instanceServer})?\\/?$`, 'i')
          if (this.instanceField.includes('127.0.0') || this.instanceField.includes('localhost') || this.instanceField.includes('https') || this.instanceField.includes('http')) field = this.instanceField
          else if ((this.instanceField.includes('org') || this.instanceField.includes('com') || this.instanceField.includes('io')) && !this.instanceField.includes('https')) {
            field = 'https://' + this.instanceField
          } else {
            field = 'https://' + this.instanceField.replace(exp, '$2') + this.instanceServer
          }
          if (field[field.length - 1] !== '/') {
            field = field + '/'
          }
          const url = await this.$store.dispatch('addInstance', field, this.instanceField.replace(exp, '$2'))
          this.handleInstanceSelect(url)
          this.instanceField = ''
          this.addingCustomInstance = false
          setTimeout(() => this.focusOnPasswordField())
        } catch (e) {
          console.log(e)
        }
      },
      hasToken () {
        return Boolean(this.creds.token)
      },
      /**
       * Finds the password field and focuses on it
       */
      focusOnPasswordField () {
        if (this.$refs && this.$refs.passwordField && this.$refs.passwordField.$el) {
          const inputEl = [...this.$refs.passwordField.$el.children].find(child => child.tagName === 'INPUT')
          if (inputEl) {
            inputEl.focus()
          }
        }
      },
      /*
      * Removes an instance
      * @param {url} URL of instance to remove
      * @return void
      */
      async removeInstance (url) {
        await this.$store.dispatch('removeInstance', url)
        setTimeout(() => {
          if (this.activeInstance && this.activeInstance.url) {
            this.handleInstanceSelect(this.activeInstance.url)
          } else {
            this.handleInstanceSelect()
          }
        })
      },
      /*
      * Sets a selected instance
      * @param {i} selected instance url
      * @return void
      */
      handleInstanceSelect (url = null) {
        let instance = {}
        if (this.instances.length) {
          instance = this.instances.find(v => v.url === url)
        } else {
          instance.url = url
          instance.name = url
        }
        if (instance) {
          this.instance = instance.url
          this.$store.dispatch('switchActiveAppInstance', instance)
        } else {
          this.instance = ''
        }
      },
      /*
      * Resets a user's password using the token that was sent to them in an email
      * @return void
      */
      async saveNewPassword () {
        try {
          // Check empty password
          if (!this.creds.password) {
            this.$message({message: 'Please enter a new password', type: 'error', duration: 10000})
            return
          }
          // Check password length has minimum 10 characters
          if (!(/.{10,}/.test(this.creds.password))) {
            this.$message({message: 'Password requires at least 10 characters', type: 'error', duration: 10000})
            return
          }
          // Check password has 1 upper case character
          if (!(/[A-Z]+/.test(this.creds.password))) {
            this.$message({message: 'Password requires at least 1 upper case character', type: 'error', duration: 10000})
            return
          }
          // Check password has 1 lower case character
          if (!(/[a-z]+/.test(this.creds.password))) {
            this.$message({message: 'Password requires at least 1 lower case character', type: 'error', duration: 10000})
            return
          }
          // Check password has 1 number
          if (!(/[0-9]+/.test(this.creds.password))) {
            this.$message({message: 'Password requires at least 1 number', type: 'error', duration: 10000})
            return
          }
          // Check password has 1 special character
          if (!(/[!@#$%^&*.?]/.test(this.creds.password))) {
            this.$message({message: 'Password requires at least 1 special character', type: 'error', duration: 10000})
            return
          }
          // Check password contains the word "password"
          if (this.creds.password.match('password')) {
            this.$message({message: 'Password cannot contain the word "password"', type: 'error', duration: 10000})
            return
          }
          if (!this.creds.password2) {
            this.$message({message: 'Please confirm your new password.', type: 'error', duration: 10000})
            return
          }
          if (this.creds.password !== this.creds.password2) {
            this.$message({message: 'The passwords you entered do not match.', type: 'error', duration: 10000})
            return
          }
          this.loading = true
          const instance = this.instances.find(instance => instance.url === this.instance)
          await this.$store.dispatch('clearState')
          await this.$store.dispatch('switchActiveAppInstance', instance)
          const payload = { token: this.creds.token, password: this.creds.password, url: this.activeInstance.url }
          await this.$store.dispatch('saveNewPassword', payload)
          this.$message(
            { message: 'Password set successfully. Logging in...', type: 'success', duration: 10000 }
          )
          const loginPayload = { username: this.creds.username, password: this.creds.password, url: this.activeInstance.url }
          await this.$store.dispatch('authenticate', loginPayload)
          if (this.$store.getters.getToken) {
            return this.$router.push('/home')
          }
          this.loading = false
        } catch (e) {
          console.log(e)
          this.creds.password = ''
          this.creds.password2 = ''
          this.addingCustomInstance = false
          this.loading = false
        }
      },
      /*
      * Calls login() when user presses the enter key
      * @return void
      */
      handleKeydown (e) {
        if (e && e.keyCode === 13) {
          this.validInstanceUrl ? this.addInstance() : this.saveNewPassword()
        }
      },
      formatInstanceURL (url) {
        // Check url is exist or not
        if (!url) return
        // Remove the protocall(https:// or http://) from the instance URL
        let instanceURL = url.replace(/(^\w+:|^)\/\//, '')
        // Remove trailing '/' from the end of instance URL
        instanceURL = instanceURL.replace(/\/+$/, '')
        return instanceURL
      }
    },
    computed: {
      ...mapGetters({
        activeInstance: 'getActiveInstance',
        instances: 'getInstances',
        instanceServer: 'getInstanceServer',
        loginRoute: 'Login'
      }),
      /**
       * Determines whether the instance URL provided is valid
       */
      validInstanceUrl () {
        return this.instanceField.includes('localhost') || isUrl(this.instanceField)
      },
      // Sort the instances data in the alphabetical order
      sortInstancesData () {
        // Check instance data or instance length are exist or not
        if (!this.instances || this.instances.length <= 0) return
        // Convert the instance data in the required format i.e., alphabetical order
        let response = this.instances.sort((a, b) => (a.name || a.url) > (b.name || b.url) ? 1 : -1)
        return response
      }
    },
    created () {
      if (this.$route.query.hasOwnProperty('instances')) {
        let instanceUrl = this.$route.query.instances
        if (instanceUrl[instanceUrl.length - 1] !== '/') {
          instanceUrl = instanceUrl + '/'
        }
        this.handleInstanceSelect(instanceUrl)
      }
      if (this.$route.query.hasOwnProperty('username')) {
        this.creds.username = this.$route.query.username
      } else {
        this.creds.username = ''
      }
      setTimeout(() => this.focusOnPasswordField())
    },
    async beforeRouteEnter (to, from, next) {
      await store.dispatch('verifyAuth')
      if (from.path === '/') {
        return next()
      }
      try {
        if (to.query.hasOwnProperty('instances') && Object.keys(to.query.instances).length) {
          await store.dispatch('fetchInstances', to.query.instances)
        } else {
          await store.dispatch('fetchInstances')
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #setup-password {
    padding: 60px 0;
    background-color: #ffffff;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .login-form-wrapper h3 {
    padding: 12px 0;
  }
  .left-padded {
    padding-left: 12px;
  }
  .v-padded-s {
    padding: 6px 0;
  }
  .login-row {
    color: #324157;
  }
  #password {
    padding: 12px 0;
  }
  #login-register-btn-wrapper {
    padding: 12px 0;
  }
  .terms-bottom {
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Auth/setupPassword.vue